import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import { ApiManagersAiCompanyContextsIndexResponseType } from "~/domains";

type RequestDataType = {
  page?: number;
};

const request = async ({
  page = 1,
}: RequestDataType): Promise<ApiManagersAiCompanyContextsIndexResponseType> => {
  const response =
    await new ApiClient().get<ApiManagersAiCompanyContextsIndexResponseType>(
      "/api/managers/ai_company_contexts",
      { page },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisManagersAiCompanyContextsIndex = ({
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApiManagersAiCompanyContextsIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisManagersAiCompanyContextsIndex"],
    ({ pageParam }) => {
      return request({
        page: pageParam as number | undefined,
      });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
